<footer>Made with ♥ in Malmö</footer>

<style>
	footer {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-block: var(--size-4);
	}
</style>
